import type { AxiosError } from 'axios';
import type { Campaign } from './types';

export const formatVnd = (value: string | number | null | undefined) =>
  value === null || value === undefined || value === ''
    ? '-'
    : `${new Intl.NumberFormat('vi-VN').format(Number(value))} ₫`;

export const formatDateTime = (value?: string | null) =>
  value ? new Date(value).toLocaleString() : '-';

export const discountLabel = (
  c: Pick<Campaign, 'discountType' | 'percentBps' | 'fixedAmountMinor' | 'maxDiscountMinor'>
) => {
  if (c.discountType === 'FIXED') return `-${formatVnd(c.fixedAmountMinor)}`;
  const pct = (c.percentBps ?? 0) / 100;
  return c.maxDiscountMinor ? `-${pct}% (max ${formatVnd(c.maxDiscountMinor)})` : `-${pct}%`;
};

/** ISO <-> value of an <input type="datetime-local"> (local time). */
export const toLocalInput = (iso: string) => {
  const date = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
export const fromLocalInput = (value: string) => new Date(value).toISOString();

const ERROR_TEXT: Record<string, string> = {
  PROMO_VALID_TO_MUST_BE_AFTER_VALID_FROM: 'End time must be after start time.',
  PROMO_PERCENT_BPS_REQUIRED: 'Enter a discount percentage.',
  PROMO_FIXED_AMOUNT_REQUIRED: 'Enter a fixed discount amount.',
  PROMO_FULL_DISCOUNT_REQUIRES_MAX_REDEMPTIONS:
    'A 100% discount requires a total redemption limit.',
  PROMO_CAMPAIGN_RULES_LOCKED:
    'This campaign already has redemptions: its discount rules cannot change. Create a new campaign instead.',
  PROMO_TARGET_FREE_OR_TRIAL_PACKAGE: 'Free and trial packages cannot be targeted.',
  PROMO_TARGET_PACKAGE_ONLY: 'This campaign only applies to packages.',
  PROMO_TARGET_TOKEN_PACK_ONLY: 'This campaign only applies to token packs.',
  COUPON_CODE_EXISTS: 'This code already exists.',
  COUPON_CODE_REQUIRED: 'Enter a code.',
  COUPON_PREFIX_REQUIRED: 'Enter a prefix for bulk generation.',
};

export const errorText = (error: unknown): string => {
  const body = (error as AxiosError<{ error?: string; message?: string }>).response?.data;
  const code = body?.error;
  return (
    (code && ERROR_TEXT[code]) || body?.message || (error as Error).message || 'Request failed'
  );
};
